import React from 'react';
export var SettingsContext = React.createContext({
    ready: false,
    set: null,
    get: null,
    getDefaultValue: null,
    reset: null,
    resetAll: null,
    publishEvent: null,
});
export var SettingsConsumer = SettingsContext.Consumer;
//# sourceMappingURL=SettingsContext.js.map